import { defineMessages } from 'react-intl';

export const scope = 'app.containers.Tooltip';

export default defineMessages({
  warningTitle: {
    id: `${scope}.warningTitle`,
    defaultMessage: 'Important note',
  },
});
